// extracted by mini-css-extract-plugin
export default {"layout":"Cards_layout__7klAa"};